import { Map } from 'immutable';
import { call, put, takeEvery } from 'redux-saga/effects';
import { action, dispatch, regHandlers, regSaga } from '../../store';
import { connect } from 'react-redux';
import { openModal } from './ConfirmationModal';

regHandlers({
  CONTROL_ACTION: (state, { payload }) =>
    state.setIn(
      ['page', 'controlGroup', payload.controlKey, payload.name, 'pending'],
      true,
    ),
  CONTROL_ACTION_SUCCESS: (state, { payload }) =>
    state.deleteIn(['page', 'controlGroup', payload.controlKey, payload.name]),
  CONTROL_ACTION_ERROR: (state, { payload }) =>
    state.mergeIn(['page', 'controlGroup', payload.controlKey, payload.name], {
      pending: false,
      error: payload.error,
    }),
  CONTROL_ACTION_CLEAR_ERROR: (state, { payload }) =>
    state.deleteIn([
      'page',
      'controlGroup',
      payload.controlKey,
      payload.action,
      'error',
    ]),
});

regSaga(
  takeEvery('CONTROL_ACTION', function*({ payload }) {
    const { controlKey, name, actionFn, args, onSuccess, onError } = payload;
    try {
      const result = yield call(actionFn, ...args);

      if (result && result.error) {
        throw result.error;
      }
      yield put(action('CONTROL_ACTION_SUCCESS', { controlKey, name }));
      if (typeof onSuccess === 'function') {
        yield call(onSuccess, result);
      }
      if (onSuccess && typeof onSuccess[name] === 'function') {
        yield call(onSuccess[name], result);
      }
    } catch (error) {
      if (error instanceof Error) {
        console.error(error);
      }
      yield put(action('CONTROL_ACTION_ERROR', { controlKey, name, error }));
      if (typeof onError === 'function') {
        yield call(onError, error);
      }
    }
  }),
);

const generateActions = (
  actions,
  confirmations,
  controlKey,
  onSuccess,
  onError,
) =>
  Map(actions)
    .map((actionFn, name) => (...args) => () => {
      const payload = { controlKey, name, actionFn, args, onSuccess, onError };
      if (confirmations[name]) {
        openModal({
          ...confirmations[name],
          ok: action('CONTROL_ACTION', payload),
        });
      } else {
        dispatch('CONTROL_ACTION', payload);
      }
    })
    .toObject();

export const mapStateToProps = (state, props) => ({
  anyErrors: state
    .getIn(['page', 'controlGroup', props.controlKey], Map())
    .some(controlState => controlState.has('error')),
  anyPending: state
    .getIn(['page', 'controlGroup', props.controlKey], Map())
    .some(controlState => controlState.get('pending')),
  errors: state
    .getIn(['page', 'controlGroup', props.controlKey], Map())
    .filter(controlState => controlState.has('error'))
    .map(controlState => controlState.get('error')),
  pending: state
    .getIn(['page', 'controlGroup', props.controlKey], Map())
    .map(controlState => controlState.get('pending', false)),
});

export const ControlGroup = connect(mapStateToProps)(props => {
  const clearError = action => () =>
    dispatch('CONTROL_ACTION_CLEAR_ERROR', {
      action,
      controlKey: props.controlKey,
    });
  return props.children({
    actions: generateActions(
      props.actions,
      props.confirmations,
      props.controlKey,
      props.onSuccess,
      props.onError,
    ),
    anyErrors: props.anyErrors,
    anyPending: props.anyPending,
    errors: props.errors,
    pending: props.pending,
    clearError,
  });
});
